// Types
import type { WhatsNewEntry, WhatsNewRole } from "./_WhatsNew.types";

/**
 * getVisibleWhatsNew(): Entries the role can use, by role type and
 * permissions. Newest first
 */
export const getVisibleWhatsNew = (
  entries: Array<WhatsNewEntry>,
  role: WhatsNewRole
): Array<WhatsNewEntry> => {
  if (!role) {
    return [];
  }
  return entries
    .filter(({ audience }) => {
      if (!audience) {
        return true;
      }
      if (audience.roles && audience.roles.indexOf(role.type) === -1) {
        return false;
      }
      if (audience.can && !audience.can(role.permissions)) {
        return false;
      }
      return true;
    })
    .sort((a, b) => (a.releasedAt < b.releasedAt ? 1 : -1));
};

/**
 * getUnseenWhatsNew(): Visible entries not marked as seen. Entries released
 * before the user was created are not new for them
 */
export const getUnseenWhatsNew = (
  visibleEntries: Array<WhatsNewEntry>,
  seenIds: Array<string>,
  userCreatedAt?: string | null
): Array<WhatsNewEntry> =>
  visibleEntries.filter(
    ({ id, releasedAt }) =>
      seenIds.indexOf(id) === -1 &&
      (!userCreatedAt || new Date(releasedAt) > new Date(userCreatedAt))
  );

/**
 * compareVersions(): Like a sort function: negative if a < b
 */
export const compareVersions = (a: string, b: string): number => {
  const aParts = a.split(".").map(Number);
  const bParts = b.split(".").map(Number);
  for (let i = 0; i < 3; i++) {
    if (aParts[i] !== bParts[i]) {
      return aParts[i] - bParts[i];
    }
  }
  return 0;
};
